define('views/quick-cart',[
  'jquery',

  'modules/pop-over',
  'modules/options-menu',
  'modules/cart-actions',

  'connections/cart-connection',

  'utils/is-fixed',

  'libs/respond/respond',

  'settings'
], function ($, PopOver, OptionsMenu, CartActions, CartConnection, isFixed, respond, settings) {
  function QuickCart() {}

  /**
   * Initializes the cart bindings
   *
   * @method _init
   * @private
   */
  QuickCart.prototype.init = function () {
    var _this = this;
    this.toggleButton = $('.header-quickcart-btn');
    var quickCart = $('#quickcart');

    this.toggleButton.on('click', function () {
      _this.toggleQuickCart();
    });
    quickCart.on('click', '.jsCloseQuickCart', function () {
      _this.closeQuickCart();
    });
    quickCart.on('click', '.jsRemoveProduct', function (e) {
      _this.removeProduct(e);
    });
    quickCart.on('click', '.jsRemoveCart', function () {
      _this.removeCart();
    });

    // Cart Actions
    quickCart.on('click', '.jsQuickCartOptions', function (e) {
      OptionsMenu.toggle(e);
    });
    OptionsMenu.addBodyCloseListener('.jsQuickCartOptions');
    ca = new CartActions();
    quickCart.on('click', '.jsSaveAsDraft', function (e) {
      ca.saveAsDraft(e);
    });
    quickCart.on('click', '.jsConvertToOffer', function (e) {
      ca.convertToOffer(e);
    });

    this.updateTotalQuantity();
  };

  /**
   * Toggle QuickCart
   */
  QuickCart.prototype.toggleQuickCart = function () {
    var _this = this,
      quickcart = $('#quickcart'),
      overlay = $('.quickcart__overlay');

    if (_this.popOverIsDisabled) return;

    quickcart.toggleClass('open');
    if (!CartConnection.cartViewLoaded) {
      _this.showLoader();
      CartConnection.getQuickCart()
        .then(function (html) {
          _this.printQuickCart(html);
        })
        .always(function () {
          _this.hideLoader();
        });
    }

    if (quickcart.hasClass('open')) {
      overlay.addClass('active');
    } else {
      overlay.removeClass('active');
    }

    overlay.off('click').on('click', function () {
      $(this).removeClass('active');
      quickcart.removeClass('open');
    });
  };

  QuickCart.prototype.closeQuickCart = function () {
    $('#quickcart').removeClass('open');
    $('.quickcart__overlay').off('click').removeClass('active');
  };

  /**
   * Shows overlay loader on Quick Cart
   *
   * @method showLoader
   * @returns {QuickCart} Returns itself for chainability
   */
  QuickCart.prototype.showLoader = function () {
    $('.quickcart__loader').addClass('quickcart__loader--visible');
    return this;
  };

  /**
   * Hide overlay loader on Quick Cart
   *
   * @method hideLoader
   * @returns {QuickCart} Returns itself for chainability
   */
  QuickCart.prototype.hideLoader = function () {
    $('.quickcart__loader').removeClass('quickcart__loader--visible');
    return this;
  };

  /**
   * Removes one product from the Cart
   */
  QuickCart.prototype.removeProduct = function (e) {
    var _this = this;
    var sku = $(e.currentTarget).closest('.quickcart-product').data('product-id');

    e.preventDefault();

    _this.showLoader();
    CartConnection.deleteProduct(sku).then(function (totalQty) {
      CartConnection.getQuickCart()
        .then(function (html) {
          _this.printTotalQuantity(totalQty);
          _this.printQuickCart(html);
        })
        .always(function () {
          _this.hideLoader();
        });
    });
  };

  /**
   * Clear the entire Cart
   */
  QuickCart.prototype.removeCart = function () {
    var _this = this;

    _this.showLoader();
    CartConnection.clear().then(function () {
      CartConnection.getQuickCart()
        .then(function (html) {
          _this.printTotalQuantity(0);
          _this.printQuickCart(html);
        })
        .always(function () {
          _this.hideLoader();
        });
    });
  };

  /**
   * Update total quantity
   *
   * @method updateTotalQuantity
   */
  QuickCart.prototype.updateTotalQuantity = function () {
    var _this = this;

    CartConnection.getTotalQuantity().then(function (res) {
      _this.printTotalQuantity(res);
    });
  };

  /**
   * Print total quantity
   *
   * @method printTotalQuantity
   */
  QuickCart.prototype.printTotalQuantity = function (count) {
    var cartCount = $('.quickcart-count');

    cartCount.removeClass('bounce');
    if (count > 0) {
      cartCount.html(count).show().addClass('bounce');
    } else {
      cartCount.hide();
    }
  };

  /**
   * Print the QuickCart partial view
   *
   * @method printQuickCart
   */
  QuickCart.prototype.printQuickCart = function (html) {
    var quickcart = $('#quickcart .aside-slidein__content');

    quickcart.html(html);
  };

  QuickCart.prototype.disablePopOver = function () {
    this.popOverIsDisabled = true;
    this.toggleButton.on('click', function (e) {
      e.preventDefault();
    });
  };

  return new QuickCart();
});

